import { Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useState } from 'react';
import RightSidebarPaper from '../../../../components/ui-component/form-component/right-side-bar/RightSidebarPaper';
import { useApplication } from '../../../../context/ApplicationContext';
import { DisplayDateTime } from '../../../../utils/formats';
import { enumT } from '../../../../utils/helper';
import { DownloadZwischenBerichtPDF } from '../DownloadAntragPDF';

import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import DownloadIcon from '@mui/icons-material/Download';

import AnsprechPartnerKontakt from '../antrag-components/AnsprechPartnerKontakt';
import RightIconButton from '../antrag-components/RightIconButton';

import Schema from '../../../../lib/paths/zwischenbericht_FULL_Paths.json';
const P = Schema.attributes;

const ZwischenBerichtRichtSidebar: FC<{}> = () => {
	const { application, saveApplication, readOnly } = useApplication();
	const [showAPKontaktdaten, setShowAPKontaktdaten] = useState(false);

	const handleOpenDialog = () => {
		setShowAPKontaktdaten(true);
	};
	const handleCloseDialog = () => {
		setShowAPKontaktdaten(false);
	};

	const handleDownloadAntrag = async () => {
		await DownloadZwischenBerichtPDF(application, readOnly, saveApplication);
	};
	return (
		<>
			<AnsprechPartnerKontakt open={showAPKontaktdaten} onClose={handleCloseDialog} application={get(application, P.Foerderantrag.path, {})} />
			<RightSidebarPaper>
				<span>
					<Typography>Online-Formular:</Typography>
					<Typography fontWeight={500} variant='body1'>
						Zwischenbericht
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Status:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Zwischenberichtstatus_Status.path))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Förderprogramm:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Projekttitel:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, 'ausstehend')}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Referenz-Nummer:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Foerderantrag.schema.attributes.Allgemein_Referenz_Nr.path, 'ausstehend')}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Erstellt am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, 'attributes.createdAt'))}
					</Typography>
				</span>

				<span>
					<Typography variant='body1'>Zuletzt geändert am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, P.Allgemein_Geaendert_Durch_Antragsteller.path, ''))}
					</Typography>
				</span>
			</RightSidebarPaper>

			<Stack direction={'row'} spacing={3} sx={{ mt: '2rem' }}>
				{(
					get(application, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '') &&
					get(application, P.Foerderantrag.schema.attributes.Allgemein_Kurzwort.path, '')
				) ?
					<RightIconButton onClick={handleDownloadAntrag} icon={<DownloadIcon />} tooltipTitle='Aktuellen Status herunterladen' />
				:	null}
				<RightIconButton onClick={handleOpenDialog} icon={<AddIcCallIcon />} tooltipTitle='Kontaktinformationen der Ansprechpartner' />
			</Stack>
		</>
	);
};

export default ZwischenBerichtRichtSidebar;
